import { toast } from "react-toastify";

const defaultConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  closeButton: true,
};

const toastHelper = {
  success: (message, config = {}) => {
    return toast.success(message, {
      ...defaultConfig,
      ...config,
    });
  },

  error: (
    message = "Something went wrong, please contact admin.",
    config = {},
  ) => {
    return toast.error(message, {
      ...defaultConfig,
      ...config,
    });
  },

  warning: (message, config = {}) => {
    return toast.warning(message, {
      ...defaultConfig,
      ...config,
    });
  },

  info: (message, config = {}) => {
    return toast.info(message, {
      ...defaultConfig,
      ...config,
    });
  },

  loading: (message, config = {}) => {
    return toast.loading(message, {
      ...defaultConfig,
      autoClose: false, // Loading toasts should NOT auto-close
      ...config,
    });
  },

  update: (toastId, message, type, config = {}) => {
    const updateConfig = {
      ...defaultConfig,
      autoClose: 5000, // Re-enable autoClose when updating to a final state
      render: message,
      type: type,
      isLoading: false,
      ...config,
    };

    toast.update(toastId, updateConfig);
  },

  dismiss: (toastId) => {
    toast.dismiss(toastId);
  },

  dismissAll: () => {
    toast.dismiss();
  },
};

export default toastHelper;
